/**
 * Form layout constants shared across admin-portal forms.
 *
 * A dropdown is sized to its options, never to the page: a full-width Select
 * stretches a one-word choice across the viewport and reads as broken. It
 * still shrinks on narrow screens because width is 100% up to the cap.
 */
export const DROPDOWN_MAX_WIDTH_PX = 480;

/** Spread onto the FormControl wrapping a Select, instead of `fullWidth`. */
export const DROPDOWN_SX = { width: '100%', maxWidth: DROPDOWN_MAX_WIDTH_PX } as const;
